export default class ItemPriceMargin {
    constructor(data?: any) {
        if (data) {
            this.id = data.id ?? 0;
            this.price = data.price ?? 0;
            this.marginPercent = data.marginPercent ?? 0;
        }
    }

    id = 0;
    price = 0;
    marginPercent = 0;
}
